module.exports = __webpack_public_path__ + "img/sdc_pic_7.6b85fda2.jpg";